module.exports = __webpack_public_path__ + "img/MEDIA064.9513fd2f.jpg";